import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import Tag from '../../models/Tag';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function updateTag(tag: Tag, auth: Authentication): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateTagFailure('Unauthorized', 'unauthorized');
  }

  try {
    await HttpClient.patch(`/tags/${tag.id}`, {
      name: tag.name,
      category: tag.category,
      id_domain: tag.idDomain,
      id_subscription: tag.idSubscription,
      prompt_instructions: tag.promptInstructions,
      color: tag.color,
    }, auth.token);
  } catch (e) {
    console.log('error: ', e);
    throw new UpdateTagFailure();
  }
}

export class UpdateTagFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateTag;
